export default __webpack_public_path__ + "static/media/gallery-1.97c9b610.jpg";